import { UserAction } from "@brookbush/types";

import { useRouter } from "next/compat/router";
import { useEffect } from "react";

import Dialog from "./Dialog";
import OnboardingChecklist from "./OnboardingChecklist";
import { useUserAction } from "~/hooks";

const OnboardingChecklistModal = () => {
	const { userAction, resetUserAction } = useUserAction();
	const router = useRouter();

	const isOpen = userAction === UserAction.OPEN_ONBOARDING_CHECKLIST;

	// Close the modal when the user picks a navigation item (route change).
	// The "Become a Member" item swaps UserAction itself, which closes it too.
	useEffect(() => {
		if (!isOpen) return;

		const handleRouteChange = () => resetUserAction();
		router?.events?.on("routeChangeStart", handleRouteChange);

		return () => {
			router?.events?.off("routeChangeStart", handleRouteChange);
		};
	}, [isOpen, router, resetUserAction]);

	return (
		<Dialog
			isOpen={isOpen}
			onClose={resetUserAction}
			title="First Steps to Get Started"
			className="max-w-md"
		>
			<OnboardingChecklist variant="modal" />
		</Dialog>
	);
};

export default OnboardingChecklistModal;
